<h2>{{ isEditMode ? 'Edit Attribute' : 'Add Attribute' }}</h2>

<mat-card appearance="outlined" [class.mat-elevation-z0]="true" class="event-attr-modal-card">
  <mat-card-content>
    <div *ngIf="!isEditMode" class="mode-tabs" fxLayout="row" fxLayoutGap="24px">
      <label><input type="radio" name="addAttrMode" [checked]="addMode==='create'" (change)="switchAddMode('create')" /> Create New</label>
      <label><input type="radio" name="addAttrMode" [checked]="addMode==='import'" (change)="switchAddMode('import')" /> Import from Template</label>
      <label><input type="radio" name="addAttrMode" [checked]="addMode==='copy'" (change)="switchAddMode('copy')" /> Copy from Event</label>
    </div>

    <form [formGroup]="formGroup" *ngIf="addMode === 'create'">
      <div fxLayout="column" fxLayoutGap="16px">
        <div
          *ngIf="showImageUpload"
          fxFlex="100"
          fxLayout="column"
          fxLayoutGap="8px"
          class="field-spacer image-top-section"
        >
          <div
            [class.image-upload-container--preview]="selectedAssetPreview"
            (click)="selectedAssetPreview && addAssetsToForm()"
          >

            <ng-container *ngIf="selectedAssetPreview as preview">

              <img
                *ngIf="preview.FileUrl && !previewImageLoadFailed"
                class="asset-preview-img"
                [src]="preview.FileUrl"
                [alt]="preview.AssetName"
                (error)="onAssetPreviewImageError()"
              />
            </ng-container>
          </div>

          <div
            *ngIf="selectedAssetPreview"
            class="img-preview-actions"
            fxLayout="row"
            fxLayoutGap="8px"
          >
            <button mat-stroked-button type="button" (click)="addAssetsToForm()">
              <mat-icon>upload</mat-icon>
              Replace
            </button>
           
          </div>

          <div
            *ngIf="!isEditMode && !selectedAssetPreview"
            fxLayout="row"
            fxLayoutAlign="start center"
            fxLayoutGap="12px"
            class="image-upload-toolbar"
          >
            <button
              mat-stroked-button
              color="primary"
              type="button"
              (click)="addAssetsToForm(); $event.stopPropagation()"
            >
              <mat-icon>folder_open</mat-icon>
              Add from Assets
            </button>
          </div>

          <mat-error
            *ngIf="formGroup.get('AssetId')?.hasError('required') && (formGroup.get('AssetId')?.touched || formGroup.get('AssetId')?.dirty)"
          >
            Asset is required
          </mat-error>
        </div>

        <div formGroupName="Detail" fxLayout="column" fxLayoutGap="16px">
          <mat-form-field appearance="outline" fxFlex="100">
            <mat-label>Attribute Type</mat-label>
            <mat-select formControlName="PrintAttributeType">
              <mat-option value="">Select type...</mat-option>
              <mat-option *ngFor="let type of attributeTypeOptions" [value]="type.id">
                {{ type.label }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="detailForm.get('PrintAttributeType')?.hasError('required')">
              Attribute Type is required
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" fxFlex="100">
            <mat-label>Name</mat-label>
            <input matInput formControlName="PrintAttributeName" />
            <mat-error *ngIf="detailForm.get('PrintAttributeName')?.hasError('required')">
              Name is required
            </mat-error>
          </mat-form-field>
        </div>

        <mat-form-field appearance="outline" fxFlex="100">
          <mat-label>Event Type</mat-label>
          <mat-select formControlName="EventTypeId">
            <mat-option *ngFor="let eventType of eventTypeOptions" [value]="eventType.id">
              {{ eventType.name }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="formGroup.get('EventTypeId')?.hasError('required')">
            Event Type is required
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" fxFlex="100">
          <mat-label>Division</mat-label>
          <mat-select
            formControlName="DivisionIds"
            multiple
            (selectionChange)="onDivisionChange($event)"
          >
            <mat-option *ngFor="let division of divisionOptions" [value]="division.id">
              {{ division.name }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="formGroup.get('DivisionIds')?.hasError('required')">
            Division is required
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" fxFlex="100">
          <mat-label>Version(s)</mat-label>
          <mat-select formControlName="VersionIds" multiple>
            <mat-option *ngFor="let v of availableVersions" [value]="v.Id">
              {{ v.VersionName }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <div
          class="page-position-row"
          fxLayout="row"
          fxLayoutGap="16px"
          fxLayoutAlign="stretch stretch"
        >
          <mat-form-field appearance="outline" fxFlex>
            <mat-label>Page</mat-label>
            <mat-select formControlName="PrintPageId">
              <mat-option value="">—</mat-option>
              <mat-option *ngFor="let p of printPagesList" [value]="p.Id">
                {{ p.PageFrom }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline" fxFlex>
            <mat-label>Position</mat-label>
            <input matInput type="number" min="-1" formControlName="Position" />
          </mat-form-field>
        </div>

        <div formGroupName="Detail" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="16px">
          <mat-form-field appearance="outline" fxFlex="49" fxFlex.lt-md="100">
            <mat-label>Client Key</mat-label>
            <input matInput formControlName="ClientKey" placeholder="Unique key for this attribute" autocomplete="off" />
            <mat-error *ngIf="detailForm.get('ClientKey')?.hasError('required')">
              Client Key is required
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" fxFlex="49" fxFlex.lt-md="100">
            <mat-label>Status</mat-label>
            <mat-select formControlName="Status">
              <mat-option [value]="AttributeStatuses.Active">Active</mat-option>
              <mat-option [value]="AttributeStatuses.Inactive">Inactive</mat-option>
            </mat-select>
            <mat-error *ngIf="detailForm.get('Status')?.hasError('required')">
              Status is required
            </mat-error>
          </mat-form-field>
        </div>

        <div formGroupName="Detail">
          <mat-form-field appearance="outline" fxFlex="100">
            <mat-label>Description</mat-label>
            <textarea matInput rows="3" formControlName="Description" placeholder="Enter description..."></textarea>
          </mat-form-field>
        </div>

        <div *ngIf="dynamicFields.length" formGroupName="Data">
          <div fxLayout="column" fxLayoutGap="16px">
            <p class="section-title">Attribute Data — {{ selectedAttributeType }}</p>
            <div class="dynamic-fields-grid" [class.dynamic-fields-grid--single]="dynamicFields.length === 1">
              <mat-form-field *ngFor="let field of dynamicFields" appearance="outline">
                <mat-label>{{ field.label }}</mat-label>
                <input
                  *ngIf="field.type !== 'date'"
                  matInput
                  [type]="field.type === 'number' ? 'number' : 'text'"
                  [formControlName]="field.id"
                  [readonly]="!!field.readOnly"
                  [placeholder]="field.placeholder || ('Enter ' + (field.label | lowercase))"
                />
                <input
                  *ngIf="field.type === 'date'"
                  matInput
                  [matDatepicker]="picker"
                  [formControlName]="field.id"
                  [placeholder]="field.placeholder || ('Select ' + (field.label | lowercase))"
                />
                <mat-datepicker-toggle
                  *ngIf="field.type === 'date'"
                  matIconSuffix
                  [for]="picker"
                ></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
                <mat-error *ngIf="getDynamicFieldControl(field.id).hasError('required')">
                  {{ field.label }} is required
                </mat-error>
                <mat-error *ngIf="getDynamicFieldControl(field.id).hasError('pattern')">
                  Enter a valid URL (https://…)
                </mat-error>
                <mat-error
                  *ngIf="
                    field.id === 'SaleEndDate' &&
                    dataFieldsForm.invalid &&
                    dataFieldsForm.hasError('saleDateRange')
                  "
                >
                  Sale start must be on or before sale end date.
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </div>

      </div>
    </form>

    <div *ngIf="addMode === 'import'" fxLayout="column" fxLayoutGap="12px">
      <ng-container *ngIf="importViewModel$ | async as viewModel">
        <p class="mode-help">Select attribute templates to import into this event.</p>
        <mat-form-field appearance="outline">
          <mat-label>Search templates</mat-label>
          <input
            matInput
            [(ngModel)]="importSearch"
            [ngModelOptions]="{standalone: true}"
            (ngModelChange)="onImportSearchChange()"
          />
          <button type="button" matSuffix mat-icon-button aria-label="Clear" *ngIf="importSearch"
            (click)="clearImportSearch()">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>

        <div class="grid-container">
          <table mat-table [dataSource]="viewModel.attributesFromTemplate" *ngIf="viewModel.attributesFromTemplate.length">
            <ng-container matColumnDef="select">
              <th class="no-ellipsis" mat-header-cell *matHeaderCellDef>
                <mat-checkbox
                  (change)="importMasterToggle()"
                  [checked]="isAllImportSelected()"
                  [indeterminate]="importSelection.selected.length > 0 && !isAllImportSelected()"
                ></mat-checkbox>
              </th>
              <td class="no-ellipsis" mat-cell *matCellDef="let row">
                <mat-checkbox
                  (click)="$event.stopPropagation()"
                  (change)="toggleImportSelect($event.checked, row)"
                  [checked]="importSelection.isSelected(row)"
                ></mat-checkbox>
              </td>
            </ng-container>

            <ng-container matColumnDef="Name">
              <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">Name</th>
              <td mat-cell *matCellDef="let row">{{ row.Detail.PrintAttributeName }}</td>
            </ng-container>

            <ng-container matColumnDef="Type">
              <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">Type</th>
              <td mat-cell *matCellDef="let row">
                <span class="attr-type-pill" [ngClass]="'print-attr-tone--' + (row.Detail.PrintAttributeType || 'unknown')">
                  {{ getPrintAttributeTypeLabel(row.Detail.PrintAttributeType) }}
                </span>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="selectionTableColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: selectionTableColumns"></tr>
          </table>

          <table *ngIf="!viewModel.attributesFromTemplate.length">
            <tr>
              <td class="no-records" [attr.colspan]="selectionTableColumns.length">
                <h2>No Records Found</h2>
              </td>
            </tr>
          </table>
        </div>

        <mat-paginator
          *ngIf="viewModel.attributesFromTemplate.length"
          [length]="viewModel.totalRecords"
          [pageSize]="viewModel.importFromTemplatePage.pageSize"
          [pageSizeOptions]="[5, 10, 20, 50, 100]"
          (page)="onImportPage($event)"
          showFirstLastButtons
          [pageIndex]="viewModel.importFromTemplatePage.pageIndex"
        ></mat-paginator>
      </ng-container>
    </div>

    <div *ngIf="addMode === 'copy'" fxLayout="column" fxLayoutGap="12px">
      <p class="mode-help">Select a source event to copy attributes from.</p>
      <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100">
          <label>Event</label>
          <mat-form-field appearance="outline" (click)="openEventsialog()">
              <input matInput readonly [formControl]="copySearchControl" placeholder="Choose Event" /><span
                  style="color: rgb(65, 65, 186); padding-right: 20px;" matSuffix>Edit</span>
          </mat-form-field>
      </div>

      <mat-form-field *ngIf="sourceEvent" appearance="outline" fxFlex="100" class="copy-attributes-search-field">
        <mat-icon matPrefix>search</mat-icon>
        <mat-label>Search attributes</mat-label>
        <input matInput [formControl]="copyAttributesSearchControl" placeholder="Filter by name or type" />
        <button
          *ngIf="copyAttributesSearchControl.value"
          type="button"
          matSuffix
          mat-icon-button
          aria-label="Clear search"
          (click)="clearCopyAttributesSearch()"
        >
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>

      <ng-container *ngIf="copyViewModel$ | async as viewModel">
        <div class="grid-container">
          <table mat-table [dataSource]="viewModel.attributesFromSourceEvent" *ngIf="viewModel.attributesFromSourceEvent.length">
            <ng-container matColumnDef="select">
              <th class="no-ellipsis" mat-header-cell *matHeaderCellDef>
                <mat-checkbox
                  (change)="copyMasterToggle()"
                  [checked]="isAllCopySelected()"
                  [indeterminate]="isSomeCopySelectedOnPage() && !isAllCopySelected()"
                ></mat-checkbox>
              </th>
              <td class="no-ellipsis" mat-cell *matCellDef="let row">
                <mat-checkbox
                  (click)="$event.stopPropagation()"
                  (change)="toggleCopySelect($event.checked, row)"
                  [checked]="selection.isSelected(row)"
                ></mat-checkbox>
              </td>
            </ng-container>

            <ng-container matColumnDef="Name">
              <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">Name</th>
              <td mat-cell *matCellDef="let row">{{ row.Detail?.PrintAttributeName }}</td>
            </ng-container>

            <ng-container matColumnDef="Type">
              <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">Type</th>
              <td mat-cell *matCellDef="let row">
                <span
                  class="attr-type-pill"
                  [ngClass]="'print-attr-tone--' + (row.Detail?.PrintAttributeType || 'unknown')"
                >
                  {{ getPrintAttributeTypeLabel(row.Detail?.PrintAttributeType) }}
                </span>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="selectionTableColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: selectionTableColumns"></tr>
          </table>

          <table *ngIf="!viewModel.attributesFromSourceEvent.length">
            <tr>
              <td class="no-records" [attr.colspan]="selectionTableColumns.length">
                <h2>{{ sourceEvent ? 'No Records Found' : 'Select a source event to load attributes' }}</h2>
              </td>
            </tr>
          </table>
        </div>

        <mat-paginator
          *ngIf="viewModel.attributesFromSourceEvent.length"
          [length]="viewModel.totalRecords"
          [pageSize]="viewModel.page.pageSize"
          [pageSizeOptions]="[5, 10, 20, 50, 100]"
          (page)="onCopyPage($event)"
          showFirstLastButtons
          [pageIndex]="viewModel.page.pageIndex"
        ></mat-paginator>
      </ng-container>
    </div>
  </mat-card-content>

  <mat-card-actions fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="15px">
    <div
      fxLayout="row"
      [fxLayoutAlign]="isEditMode && addMode === 'create' ? 'space-between' : 'end'"
      class="mat-card-actions-details"
    >
      <button
        *ngIf="isEditMode && addMode === 'create' && !readOnlyMode"
        mat-raised-button
        color="warn"
        type="button"
        (click)="deleteAttribute()"
      >
        Delete
      </button>
      <div fxLayout="row" fxLayoutAlign="end start" fxLayoutGap="16px">
        <button mat-stroked-button type="button" (click)="cancel()">Cancel</button>

        <ng-container *ngIf="addMode === 'copy'">
          <button [disabled]="!sourceEvent?.DomainId || !copyAttributesList.length" mat-raised-button type="button" color="accent" (click)="copyAll()">Copy All</button>
          <button [disabled]="selection.selected.length === 0" mat-raised-button type="button" color="accent" (click)="save()">Copy Selected</button>
        </ng-container>
        <ng-container *ngIf="addMode === 'import'">
          <button [disabled]="importSelection.selected.length === 0" mat-raised-button type="button" color="accent" (click)="save()">Import Selected</button>
        </ng-container>
        <ng-container *ngIf="addMode === 'create'">
          <button [disabled]="formGroup.invalid || readOnlyMode" mat-raised-button type="button" color="accent" (click)="save()">Save</button>
        </ng-container>
      </div>
    </div>
  </mat-card-actions>
</mat-card>
